<template>
<div class="wenhui-tech-contact">
    <!-- 科技感Banner -->
    <div class="tech-contact-banner">
        <div class="banner-content">
            <h1>技术咨询</h1>
            <p>专业工程师一对一服务</p>
            <div class="tech-particles">
                <div class="particle" v-for="i in 20" :key="i" :style="{
                         left: `${Math.random()*100}%`,
                         top: `${Math.random()*100}%`,
                         animationDelay: `${Math.random()*2}s`
                     }"></div>
            </div>
        </div>
    </div>

    <!-- 联系信息区域 -->
    <div class="section tech-contact-section">
        <div class="container">
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="tech-contact-card">
                        <h2 class="section-title">技术<span class="tech-highlight">支持</span></h2>
                        <div class="tech-contact-info">
                            <div class="info-item">
                                <div class="info-icon">
                                    <i class="el-icon-location"></i>
                                </div>
                                <div class="info-content">
                                    <h3>公司地址</h3>
                                    <p>武汉市硚口区解放大道578号中御广场2-10-2</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <i class="el-icon-phone"></i>
                                </div>
                                <div class="info-content">
                                    <h3>技术支持热线</h3>
                                    <p>18171348330 (9:00-18:00)</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <i class="el-icon-message"></i>
                                </div>
                                <div class="info-content">
                                    <h3>技术咨询邮箱</h3>
                                    <p>support@wenhuiyun.com</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <div class="info-icon">
                                    <i class="el-icon-time"></i>
                                </div>
                                <div class="info-content">
                                    <h3>服务时间</h3>
                                    <p>周一至周五: 9:00 - 18:00</p>
                                    <p>紧急问题: 24小时响应</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12">
                    <div class="tech-map-container">
                        <div class="tech-map">
                            <iframe src="https://maps.google.com/maps?q=武汉市硚口区解放大道578号中御广场2-10-2&output=embed" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <div class="tech-map-overlay">
                            <div class="tech-map-code">
                                <img src="@/assets/images/base.png" alt="微信公众号二维码">
                                <p>扫码关注获取技术支持</p>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>

    <!-- 咨询表单区域 -->
    <div class="section tech-form-section">
        <div class="container">
            <h2 class="section-title">技术<span class="tech-highlight">咨询</span></h2>
            <p class="section-subtitle">填写表单，我们的技术顾问将在1小时内响应</p>

            <el-form ref="consultForm" :model="form" :rules="rules" label-position="top" class="tech-consult-form">
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="您的姓名" prop="name">
                            <el-input v-model="form.name" placeholder="请输入姓名">
                                <i slot="prefix" class="el-icon-user tech-input-icon"></i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="联系电话" prop="phone">
                            <el-input v-model="form.phone" placeholder="请输入手机号码">
                                <i slot="prefix" class="el-icon-phone tech-input-icon"></i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="咨询类型" prop="type">
                            <el-select v-model="form.type" placeholder="请选择咨询类型">
                                <el-option v-for="item in consultTypes" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="紧急程度" prop="urgency">
                            <el-select v-model="form.urgency" placeholder="请选择紧急程度">
                                <el-option v-for="item in urgencyLevels" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="问题描述" prop="description">
                    <el-input type="textarea" :rows="5" v-model="form.description" placeholder="请详细描述您遇到的技术问题或需求" resize="none">
                    </el-input>
                </el-form-item>

                <el-form-item label="相关附件" prop="attachments">
                    <el-upload action="https://jsonplaceholder.typicode.com/posts/" multiple :limit="3" :on-exceed="handleExceed" :file-list="fileList">
                        <el-button size="small" type="primary" icon="el-icon-upload">
                            点击上传
                        </el-button>
                        <span slot="tip" class="el-upload__tip">可上传截图或日志文件(不超过3个)</span>
                    </el-upload>
                </el-form-item>

                <el-form-item class="tech-submit-item">
                    <el-button type="primary" round class="tech-submit-btn" @click="submitForm('consultForm')" :loading="submitting">
                        <i class="el-icon-s-promotion"></i> 提交咨询
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'WenhuiTechContact',
    data() {
        return {
            submitting: false,
            form: {
                name: '',
                phone: '',
                type: '',
                urgency: '',
                description: '',
                attachments: []
            },
            fileList: [],
            rules: {
                name: [{
                    required: true,
                    message: '请输入姓名',
                    trigger: 'blur'
                }],
                phone: [{
                        required: true,
                        message: '请输入手机号码',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^1[3-9]\d{9}$/,
                        message: '请输入正确的手机号码',
                        trigger: 'blur'
                    }
                ],
                type: [{
                    required: true,
                    message: '请选择咨询类型',
                    trigger: 'change'
                }],
                urgency: [{
                    required: true,
                    message: '请选择紧急程度',
                    trigger: 'change'
                }],
                description: [{
                    required: true,
                    message: '请输入问题描述',
                    trigger: 'blur'
                }]
            },
            consultTypes: [{
                    value: 'training',
                    label: '培训咨询'
                },
                {
                    value: 'development',
                    label: '开发咨询'
                },
                {
                    value: 'technical',
                    label: '技术问题'
                },
                {
                    value: 'business',
                    label: '商务合作'
                }
            ],
            urgencyLevels: [{
                    value: 'low',
                    label: '一般咨询'
                },
                {
                    value: 'medium',
                    label: '急需解决'
                },
                {
                    value: 'high',
                    label: '紧急问题'
                }
            ]
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitting = true;
                    // 模拟API请求
                    setTimeout(() => {
                        this.$message.success('咨询提交成功！我们的技术顾问将尽快联系您');
                        this.$refs[formName].resetFields();
                        this.fileList = [];
                        this.submitting = false;
                    }, 1500);
                }
            });
        },
        handleExceed(files, fileList) {
            this.$message.warning(`最多上传3个文件，当前选择了 ${files.length} 个文件，共 ${files.length + fileList.length} 个`);
        }
    }
}
</script>

<style lang="scss" scoped>
.wenhui-tech-contact {
    padding-top: 80px;
    background-color: #f5f7fa;

    .tech-contact-banner {
        height: 500px;
        background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #fff;
        position: relative;
        overflow: hidden;

        .banner-content {
            position: relative;
            z-index: 2;

            h1 {
                font-size: 60px;
                margin: 0 0 15px;
                font-weight: 700;
                text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            }

            p {
                font-size: 24px;
                margin: 0;
                opacity: 0.9;
            }
        }

        .tech-particles {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;

            .particle {
                position: absolute;
                width: 3px;
                height: 3px;
                background: rgba(255, 255, 255, 0.7);
                border-radius: 50%;
                animation: float 5s infinite ease-in-out;
                opacity: 0.7;
            }
        }
    }

    .section {
        padding: 80px 0;

        &.tech-contact-section {
            background-color: #fff;
        }

        &.tech-form-section {
            background-color: #f5f7fa;
        }
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .section-title {
        text-align: center;
        font-size: 42px;
        color: #333;
        margin-bottom: 15px;
        position: relative;
        font-weight: 700;

        .tech-highlight {
            color: #409EFF;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: 5px;
                left: 0;
                width: 100%;
                height: 10px;
                background: rgba(64, 158, 255, 0.2);
                z-index: -1;
            }
        }
    }

    .section-subtitle {
        text-align: center;
        font-size: 20px;
        color: #666;
        margin-bottom: 50px;
    }

    .tech-contact-card {
        background: #fff;
        border-radius: 12px;
        padding: 40px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
        height: 100%;

        .tech-contact-info {
            .info-item {
                display: flex;
                margin-bottom: 30px;

                .info-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: #e6f1ff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 20px;
                    flex-shrink: 0;

                    i {
                        font-size: 24px;
                        color: #409EFF;
                    }
                }

                .info-content {
                    h3 {
                        margin: 0 0 10px;
                        color: #333;
                        font-size: 18px;
                    }

                    p {
                        margin: 5px 0 0;
                        color: #666;
                        line-height: 1.6;
                    }
                }
            }
        }
    }

    .tech-map-container {
        position: relative;
        height: 100%;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

        .tech-map {
            height: 100%;

            iframe {
                width: 100%;
                height: 500px;
                border: none;
            }
        }

        .tech-map-overlay {
            position: absolute;
            bottom: 20px;
            right: 20px;
            background: rgba(255, 255, 255, 0.9);
            padding: 15px;
            border-radius: 8px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            text-align: center;

            .tech-map-code {
                img {
                    width: 120px;
                    height: 120px;
                    margin-bottom: 10px;
                }

                p {
                    margin: 0;
                    font-size: 14px;
                    color: #333;
                }
            }
        }
    }

    .tech-consult-form {
        max-width: 800px;
        margin: 0 auto;
        background: #fff;
        padding: 40px;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

        /deep/ .el-form-item__label {
            font-size: 16px;
            color: #333;
            padding-bottom: 8px;
            font-weight: 500;
        }

        /deep/ .el-input__inner,
        /deep/ .el-textarea__inner {
            border-radius: 8px;
            padding-left: 40px;
            border: 1px solid #dcdfe6;
            transition: all 0.3s;

            &:focus {
                border-color: #409EFF;
                box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
            }
        }

        .tech-input-icon {
            color: #409EFF;
            font-size: 16px;
            margin-left: 5px;
        }

        /deep/ .el-select {
            width: 100%;
        }

        /deep/ .el-upload__tip {
            font-size: 12px;
            color: #999;
            margin-top: 5px;
        }

        .tech-submit-item {
            margin-top: 30px;
            text-align: center;

            .tech-submit-btn {
                width: 200px;
                height: 50px;
                font-size: 16px;
                letter-spacing: 1px;
                transition: all 0.3s;

                i {
                    margin-right: 8px;
                }

                &:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
                }
            }
        }
    }

    @media (max-width: 992px) {
        .tech-contact-banner {
            height: 400px;

            h1 {
                font-size: 48px;
            }

            p {
                font-size: 20px;
            }
        }

        .tech-map {
            iframe {
                height: 400px !important;
            }
        }
    }

    @media (max-width: 768px) {
        .tech-contact-banner {
            height: 350px;

            h1 {
                font-size: 36px;
            }

            p {
                font-size: 18px;
            }
        }

        .section {
            padding: 60px 0;
        }

        .tech-contact-card {
            padding: 30px;
            margin-bottom: 30px;
        }

        .tech-consult-form {
            padding: 30px 20px;

            .tech-submit-item .tech-submit-btn {
                width: 100%;
            }
        }
    }

    @media (max-width: 576px) {
        .tech-contact-banner {
            height: 300px;

            h1 {
                font-size: 28px;
            }

            p {
                font-size: 16px;
            }
        }

        .section-title {
            font-size: 32px;
        }
    }
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-20px);
    }
}
</style>
